import { useLocale } from 'next-intl';
import { useMemo } from 'react';
import { getDateLocale } from '../utils/date';

const useDateLocale = () => {
  const locale = useLocale();
  const dateLocale = useMemo(() => getDateLocale(locale), [locale]);
  return dateLocale;
};

export default useDateLocale;
